import { render, staticRenderFns } from "./SignatureReader.vue?vue&type=template&id=293f10c0&scoped=true&"
import script from "./SignatureReader.vue?vue&type=script&lang=js&"
export * from "./SignatureReader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293f10c0",
  null
  
)

export default component.exports